import { actionTypes } from '@/core/constants'
import api from '@/core/apiclient'

export default {
	async [actionTypes.ITEM_ATA.BLOQUEIO.HISTORICO.BUSCAR_HISTORICOS]({ state }, idItemAta) {
		const { paginacao } = state
		const { data } = await api.bloqueio.buscarHistoricoBloqueio(idItemAta, paginacao)
		return data
	},
}
